import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3ae4e7c0&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=3ae4e7c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4e7c0",
  null
  
)

export default component.exports